/**
 * Accordion theme
 * @see https://github.com/chakra-ui/chakra-ui/blob/v2/packages/theme/src/components/accordion.ts
 */
import { accordionAnatomy as parts } from '@chakra-ui/anatomy';
export const Accordion = {
    parts: parts.keys,
    baseStyle() {
        return {
            container: {
                borderTop: 'none',
                borderBottom: 'none',
            },
            button: {
                px: '0px',
                textAlign: 'left',
            },
            icon: {
                boxSize: '24px',
            },
            panel: {
                color: 'brand.gray-scale-light-grey',
            },
        };
    },
    variants: {},
    sizes: {},
    defaultProps: {},
};
